<template>
    <div>
        <v-dialog v-model="openPopUp" persistent width="506" class="align-center">
            <template>
                <v-card height="480">
                    <v-toolbar :elevation="0" color="primary" dark>
                        <v-toolbar-title>Edit account info</v-toolbar-title>
                    </v-toolbar>
                    <v-form ref="form" class="text-center mt-n2">
                            <v-row class="mx-auto">
                                <v-col class="text-left">
                                    <v-row class="text-left mx-auto mt-3 mb-auto">Minutes to alert</v-row>
                                    <v-text-field
                                        v-model="minutesToDanger"
                                        :label="currUser.minutesToDanger"
                                        type="number"
                                        return-object
                                        outlined
                                        flat
                                        dense
                                        solo
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-auto mb-n2">
                                <v-col class="text-left">
                                    <v-row class="text-left mx-auto mt-1 mb-auto">State</v-row>
                                    <v-autocomplete
                                        v-model="state"
                                        :label="currUser.state"
                                        :items="states"
                                        item-text="name"
                                        item-value="id"
                                        return-object
                                        outlined
                                        dense
                                        solo
                                        flat
                                        @input="setState"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row class="mx-auto mb-n2 mt-n7">
                                <v-col class="text-left">
                                    <v-row class="text-left mx-auto mt-1 mb-auto">City</v-row>
                                    <v-autocomplete
                                        v-model="city"
                                        :label="currUser.city"
                                        :items="cities"
                                        return-object
                                        outlined
                                        dense
                                        solo
                                        flat
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                    </v-form>
                    <div>
                        <v-row class="ma-2">
                            <v-btn 
                                color="accent" 
                                block
                                @click="saveData">Save</v-btn>
                        </v-row>
                        <v-row class="ma-2">
                            <v-btn 
                                class="white--text" 
                                color="blue-grey lighten-1" 
                                block
                                @click="closeDialog">Cancel</v-btn>
                        </v-row>
                    </div>
                </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
export default {
    name: 'formAccountInfo',
    props: ['openPopUp','currUser'],
     computed: {
        ...mapState('user', {
            user: state => state.profile,
        })
    },
    data() {
        return {
            state: { id: null, name: null},
            states: [
                { id:0, name:'Chihuahua' },
                { id:1, name:'Nuevo León'},
                { id:2, name:'Quintana Roo' },
                { id:3, name:'Querétaro' },
                { id:4, name:'San Luis Potosí' },
                { id:4, name:'Guanajuato' },
                { id:5, name: 'Ciudad de México'},
                { id:6, name: 'Yucatán' },
                { id:6, name: 'Jalisco' },
                { id:7, name: 'Estado de México'}
            ],
            cities: null,
            city: '',
            minutesToDanger: ''
        }
    },
    methods: {
        ...mapActions({ 
            editUser: 'user/editUser'
        }),
        async saveData() {
            let u_minutesToDanger = this.minutesToDanger
            let u_state = this.state.name
            let u_city = this.city
            await this.editUser({u_minutesToDanger, u_state, u_city})
            this.closeDialog()
        },
        closeDialog() {
            this.$emit('close')
        },
        async statesList() {
            const country = { "country": "mexico" };
            const response = await axios.post("https://countriesnow.space/api/v0.1/countries/cities", country);
            let arrayStates = response.data.data
        },
        async citiesList() {
            const country = { "country": "mexico" };
            const response = await axios.post("https://countriesnow.space/api/v0.1/countries/cities", country);
        },
        setState() {
            let id = this.state.id
            let cities = [
                ['Ciudad Juárez', 'Chihuahua'],
                ['Apodaca', 'Ciénega de Flores','Escobedo','García', 'Guadalupe', 'Monterrey','San Pedro Garza García'],
                ['Cancún'],
                ['Querétaro'],
                ['San Luis Potosí'],
                ['Guanajuato', 'Romita'],
                ['Ciudad de México'],
                ['Mérida'],
                ['Ciudad Guzmán', 'Guadalajara'],
                ['Toluca']
            ]
            this.cities = cities[this.state.id]
        }
    },
    mounted(){
        this.state = {id: null, name: null}
        this.minutesToDanger = this.user.minutesToDanger
        this.state.name = this.user.state
        this.city = this.user.city
    }
}
</script>